export default __webpack_public_path__ + "static/media/help_icon.27f687fb.svg";